import { render, staticRenderFns } from "./insurer-plan-policy.vue?vue&type=template&id=f50ecdf2&scoped=true&"
import script from "./insurer-plan-policy.vue?vue&type=script&lang=js&"
export * from "./insurer-plan-policy.vue?vue&type=script&lang=js&"
import style0 from "./insurer-plan-policy.vue?vue&type=style&index=0&id=f50ecdf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50ecdf2",
  null
  
)

export default component.exports